import { render, staticRenderFns } from "./UploadFileVm.vue?vue&type=template&id=1478ed63"
import script from "./UploadFileVm.vue?vue&type=script&lang=js"
export * from "./UploadFileVm.vue?vue&type=script&lang=js"
import style0 from "./UploadFileVm.vue?vue&type=style&index=0&id=1478ed63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports